export const kurtaPage1=[
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/b/4/m/m-na-kurta-set-010-rama-woxen-original-imagzkgg8mnyxmcg.jpeg?q=70",
        "brand": "WOXEN",
        "title": "Women Kurta and Pant Set Art Silk",
        "color": "",
        "selling_price": "₹699",
        "price": "₹2,899",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/2/l/r/l-6909-blue-libas-original-imafygzxftqzszfx-bb.jpeg?q=70",
        "brand": "LIBAS",
        "title": "Women Kurta and Palazzo Set Cotton Blend",
        "color": "",
        "selling_price": "₹1,082",
        "price": "₹2,799",
        "disscount": "61% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l3t2fm80/ethnic-set/o/q/7/m-9kbd183-samah-original-imageuh5a8hgwusj.jpeg?q=70",
        "brand": "Samah",
        "title": "Women Kurta, Pant And Dupatta Set Silk Blend, Cotton Bl...",
        "color": "",
        "selling_price": "₹702",
        "price": "₹3,997",
        "disscount": "82% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l2z26q80/ethnic-set/s/n/m/xxl-blue-indigoset-klosia-original-image7c4dckmy2tt.jpeg?q=70",
        "brand": "Klosia",
        "title": "Women Kurta, Pant And Dupatta Set Viscose Rayon",
        "color": "",
        "selling_price": "₹664",
        "price": "₹2,999",
        "disscount": "77% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l0mr7gw0/ethnic-set/e/r/w/m-palazoo-set-kenix-world-original-imagcdtgpszm7cdy.jpeg?q=70",
        "brand": "shoecom",
        "title": "Women Kurta and Palazzo Set Viscose Rayon",
        "color": "",
        "selling_price": "₹433",
        "price": "₹2,995",
        "disscount": "85% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/c/t/z/l-vj-1-maroon-dupatta-set-prisca-original-imagb7evryurffsz-bb.jpeg?q=70",
        "brand": "PRISCA",
        "title": "Women Kurta and Pant Set Viscose Rayon",
        "color": "",
        "selling_price": "₹779",
        "price": "₹1,299",
        "disscount": "40% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l4u7vrk0/ethnic-set/u/h/4/m-e916-the-style-story-original-imagfmqguehvhen3.jpeg?q=70",
        "brand": "The Style Story",
        "title": "Women Kurta, Pyjama & Dupatta Set Viscose Rayon",
        "color": "",
        "selling_price": "₹748",
        "price": "₹1,999",
        "disscount": "62% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/j/t/a/xl-mk-01-peech-marudhara-original-imagzwze8huxjfgf.jpeg?q=70",
        "brand": "Marudhara",
        "title": "Women Kurta and Pant Set Pure Cotton",
        "color": "",
        "selling_price": "₹499",
        "price": "₹1,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/l/7/u/l-vfku1833skd-vbuyz-original-imaggtqkmyvjzjey.jpeg?q=70",
        "brand": "Vbuyz",
        "title": "Women Kurta, Pant And Dupatta Set Pure Cotton",
        "color": "",
        "selling_price": "₹1,540",
        "price": "₹5,799",
        "disscount": "73% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/f/7/h/xxl-riya-blue-klosia-original-imagghg2ufvshyfr.jpeg?q=70",
        "brand": "Klosia",
        "title": "Women Kurta and Palazzo Set Viscose Rayon",
        "color": "",
        "selling_price": "₹664",
        "price": "₹2,999",
        "disscount": "77% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/2/b/b/xxl-20257o-blue-libas-original-imag6xze3wpu7w4h-bb.jpeg?q=70",
        "brand": "LIBAS",
        "title": "Women Kurta and Palazzo Set Silk Blend",
        "color": "",
        "selling_price": "₹1,557",
        "price": "₹3,499",
        "disscount": "55% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kw2fki80/ethnic-set/k/i/k/xxl-201-jaipuri-collection-original-imag8tvaw4ddrtah.jpeg?q=70",
        "brand": "flamingo blue",
        "title": "Women Kurta and Palazzo Set Viscose Rayon",
        "color": "",
        "selling_price": "₹799",
        "price": "₹2,199",
        "disscount": "63% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l3t2fm80/ethnic-set/u/2/1/l-jk173-jai-kurties-original-imageugcbqk36gvg.jpeg?q=70",
        "brand": "Jai Kurties",
        "title": "Women Kurta and Pant Set Viscose Rayon",
        "color": "",
        "selling_price": "₹476",
        "price": "₹1,999",
        "disscount": "76% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l47cu4w0/ethnic-set/m/o/c/xxl-noorimauve-stylum-original-imagf5sybg5a9kt6.jpeg?q=70",
        "brand": "Stylum",
        "title": "Women Kurta and Pant Set Cotton Blend",
        "color": "",
        "selling_price": "₹769",
        "price": "₹2,499",
        "disscount": "69% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/ku8pbbk0/kurta/9/k/r/xxl-ac2-danevart-original-imag7esftepgq4fm.jpeg?q=70",
        "brand": "NEW STYLISH",
        "title": "Women Kurta and Palazzo Set Cotton Blend",
        "color": "",
        "selling_price": "₹492",
        "price": "₹1,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/m/m/a/s-sheks7041-khn-shewill-original-imagk83qhkktc3mc.jpeg?q=70",
        "brand": "SheWill",
        "title": "Women Kurta, Pant And Dupatta Set Silk Blend",
        "color": "",
        "selling_price": "₹1,649",
        "price": "₹7,359",
        "disscount": "77% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kve530w0/ethnic-set/m/h/g/xxl-fb0035pant-flamingo-blue-original-imag8at7d2pg2az3.jpeg?q=70",
        "brand": "flamingo blue",
        "title": "Women Kurta and Pant Set Viscose Rayon",
        "color": "",
        "selling_price": "₹499",
        "price": "₹1,899",
        "disscount": "73% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/t/h/i/xs-na-om-2115-f-shobhit-original-imagz3rgjtyadxfd.jpeg?q=70",
        "brand": "shobhit",
        "title": "Women Kurta and Palazzo Set Viscose Rayon",
        "color": "",
        "selling_price": "₹599",
        "price": "₹1,699",
        "disscount": "64% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l02r1jk0/ethnic-set/p/z/j/xxl-red-rose-set-klosia-original-imagby7qwgayydha.jpeg?q=70",
        "brand": "Klosia",
        "title": "Women Kurta and Dupatta Set Viscose Rayon",
        "color": "",
        "selling_price": "₹654",
        "price": "₹2,999",
        "disscount": "78% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/a/y/e/s-stylish229-h-ngreenstraightkurta-new-stylish-original-imagh9wvsaznj8ug.jpeg?q=70",
        "brand": "NEW STYLISH",
        "title": "Women Kurta and Palazzo Set Cotton Blend",
        "color": "",
        "selling_price": "₹488",
        "price": "₹1,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/ku4ezrk0/ethnic-set/v/d/2/xs-om-1164-shobhit-original-imag7bf847vzkfeh.jpeg?q=70",
        "brand": "shobhit",
        "title": "Women Kurta and Palazzo Set Viscose Rayon",
        "color": "",
        "selling_price": "₹405",
        "price": "₹1,899",
        "disscount": "78% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/l/w/y/4xl-af-3186-kpd-aayufab-original-imagztgz75hjmzhj.jpeg?q=70",
        "brand": "AAYUFAB",
        "title": "Women Kurta, Pant And Dupatta Set Pure Cotton",
        "color": "",
        "selling_price": "₹999",
        "price": "₹1,999",
        "disscount": "50% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kog30y80/ethnic-set/g/z/u/xs-pkset1025-ahika-original-imag2wenczdttdfs.jpeg?q=70",
        "brand": "AHIKA",
        "title": "Women Kurta and Pant Set Crepe",
        "color": "",
        "selling_price": "₹413",
        "price": "₹2,497",
        "disscount": "83% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l5e81ow0/ethnic-set/h/k/i/xl-mehek-suit-klosia-original-imagg2qkegyhhb9p.jpeg?q=70",
        "brand": "Klosia",
        "title": "Women Kurta and Pant Set Viscose Rayon",
        "color": "",
        "selling_price": "₹664",
        "price": "₹2,999",
        "disscount": "77% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kkbh8cw0/ethnic-set/v/r/a/m-991green-vastranikhar-original-imafzzs92fvyx6fy.jpeg?q=70",
        "brand": "Vastranikhar",
        "title": "Women Kurta and Palazzo Set Viscose Rayon",
        "color": "",
        "selling_price": "₹623",
        "price": "₹2,999",
        "disscount": "79% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/5/k/m/s-emp8027blue-emperus-original-imagyzrm6zbtqfbt-bb.jpeg?q=70",
        "brand": "Emperus",
        "title": "Women Kurta and Skirt Set Viscose Rayon",
        "color": "",
        "selling_price": "₹545",
        "price": "₹2,999",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l1b1oy80/ethnic-set/d/i/6/l-22fews15826-116338-w-original-imagcwmhesgvydju.jpeg?q=70",
        "brand": "W",
        "title": "Women Kurta and Palazzo Set Pure Cotton",
        "color": "",
        "selling_price": "₹1,399",
        "price": "₹3,999",
        "disscount": "65% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/0/z/g/3xl-na-vv-9422-vredevogel-original-imagz4rfghba9fgz.jpeg?q=70",
        "brand": "VredeVogel",
        "title": "Women Kurta, Pant And Dupatta Set Cotton Silk",
        "color": "",
        "selling_price": "₹999",
        "price": "₹4,299",
        "disscount": "76% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l2z26q80/ethnic-set/s/n/m/xxl-blue-indigoset-klosia-original-image7c4dckmy2tt.jpeg?q=70",
        "brand": "Klosia",
        "title": "Women Kurta, Pant And Dupatta Set Viscose Rayon",
        "color": "",
        "selling_price": "₹664",
        "price": "₹2,999",
        "disscount": "77% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l0sgyvk0/ethnic-set/i/x/z/m-vv-9199-vredevogel-original-imagcg5avty2apbw.jpeg?q=70",
        "brand": "VredeVogel",
        "title": "Women Kurta and Pant Set Silk Blend",
        "color": "",
        "selling_price": "₹779",
        "price": "₹2,999",
        "disscount": "74% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/4/h/g/xl-kurta-and-pant-set-01-aayufab-original-imagg9unsxquzy24.jpeg?q=70",
        "brand": "AAYUFAB",
        "title": "Women Kurta and Pant Set Viscose Rayon",
        "color": "",
        "selling_price": "₹619",
        "price": "₹1,499",
        "disscount": "58% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l3hmwsw0/ethnic-set/o/i/d/l-neckembroidery-cotton-aayufab-original-imagehnagjmgax88.jpeg?q=70",
        "brand": "AAYUFAB",
        "title": "Women Kurta and Pant Set Cotton Blend",
        "color": "",
        "selling_price": "₹649",
        "price": "₹1,999",
        "disscount": "67% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/ksdjma80/salwar-kurta-dupatta/f/z/5/xxl-vfku1106skd-vbuyz-original-imag5ybruudkzf5r.jpeg?q=70",
        "brand": "Vbuyz",
        "title": "Women Kurta, Pyjama & Dupatta Set Pure Cotton",
        "color": "",
        "selling_price": "₹1,454",
        "price": "₹4,499",
        "disscount": "67% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/l0mr7gw0/ethnic-set/p/e/n/m-palazoo-set-kenix-world-original-imagcdtgh3ra7czp.jpeg?q=70",
        "brand": "shoecom",
        "title": "Women Kurta and Palazzo Set Viscose Rayon",
        "color": "",
        "selling_price": "₹433",
        "price": "₹2,995",
        "disscount": "85% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/i/c/8/l-surya-suit-klosia-original-imaghjhyskzfhzhq.jpeg?q=70",
        "brand": "Klosia",
        "title": "Women Kurta and Pant Set Pure Cotton",
        "color": "",
        "selling_price": "₹699",
        "price": "₹2,999",
        "disscount": "76% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/ethnic-set/x/h/x/s-tr-prashant-trahimam-original-imagg6grkbzbcwpn.jpeg?q=70",
        "brand": "TRAHIMAM",
        "title": "Women Kurta and Pant Set Cotton Blend",
        "color": "",
        "selling_price": "₹389",
        "price": "₹1,999",
        "disscount": "80% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-ethnic-set/r/c/t/xxl-1-maa-collection-original-imagmcn2ezkvkkxf.jpeg?q=70",
        "brand": "Maa Collection",
        "title": "Women Kurta, Pant And Dupatta Set Viscose Rayon",
        "color": "",
        "selling_price": "₹679",
        "price": "₹1,299",
        "disscount": "47% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kit6hzk0-0/ethnic-set/6/r/p/s-6915-green-libas-original-imafygztfj6cw29c.jpeg?q=70",
        "brand": "LIBAS",
        "title": "Women Kurta and Palazzo Set Cotton Blend",
        "color": "",
        "selling_price": "₹1,019",
        "price": "₹2,999",
        "disscount": "66% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/salwar-kurta-dupatta/c/2/s/m-bunnai-butti-m-dachima-original-imaggz9axrqadjvz.jpeg?q=70",
        "brand": "DACHIMA",
        "title": "Women Pure Cotton Printed Straight Kurta with Pant & Du...",
        "color": "",
        "selling_price": "₹590",
        "price": "₹2,499",
        "disscount": "76% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kasjjww0/ethnic-set/g/u/c/3xl-j0003-set-janasya-original-imafsadzyzarf93y.jpeg?q=70",
        "brand": "Janasya",
        "title": "Women Kurta and Palazzo Set Poly Silk",
        "color": "",
        "selling_price": "₹879",
        "price": "₹2,199",
        "disscount": "60% off",
        "size": ""
    }
]